<script>
    import Button from './Button.svelte';

    export let title = "New";
</script>

<Button {title} width="30px" height="30px" on:click>
    <svg height=12 width=12>
        <line x1=0 y1=6 x2=12 y2=6 />
        <line x1=6 y1=0 x2=6 y2=12 />
    </svg>
</Button>

<style>
    line {
        stroke: #fff;
        stroke-width: 2px;
    }
</style>